/**
 * Enum for metric trend direction
 */
export enum MetricTrend {
  UP = 'UP',
  DOWN = 'DOWN',
  NEUTRAL = 'NEUTRAL',
}

/**
 * Enum for dashboard time period selection
 */
export enum DashboardTimePeriod {
  ALL_TIME = 'ALL_TIME',
  LAST_MONTH = 'LAST_MONTH',
  LAST_3_MONTHS = 'LAST_3_MONTHS',
  LAST_YEAR = 'LAST_YEAR',
}

/**
 * Interface for a single dashboard metric with trend information
 */
export interface DashboardMetric {
  value: number;
  percentageChange: number;
  trend: MetricTrend;
}

/**
 * Interface for dashboard summary containing all metrics
 */
export interface DashboardSummary {
  totalContentViews: DashboardMetric;
  activeInfluencers: DashboardMetric;
  averageTimeOnPortal: DashboardMetric;
}
